'use strict';

import angular from 'angular';
import '../app.js';

/*
When the react native mobile apps need to do external payment, they will open a webview to go to the external payment
page.  When the external payment flow is complete they will redirect to this page.  The purpose of this page is to tell
the react native mobile apps that the payment flow is complete and they can close the webview.
 */
angular.module('checkout').controller('ExternalPaymentCtrl', ['$scope', function($scope) {
    if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({name: 'payment_complete', payload: true}));
    }
}]);
